(function(){
  function hideHomepageWidgets(){
    document.querySelectorAll('#yotpo-reviews-tab').forEach(function(el){
      el.style.setProperty('display','none','important');
      el.style.setProperty('visibility','hidden','important');
      el.style.setProperty('pointer-events','none','important');
    });
  }
  hideHomepageWidgets();
  if('MutationObserver' in window){
    new MutationObserver(hideHomepageWidgets).observe(document.documentElement,{childList:true,subtree:true});
  }

  var reveals=document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}
      });
    },{threshold:0.12,rootMargin:'0px 0px -60px 0px'});
    reveals.forEach(function(el){io.observe(el);});
  }else{
    reveals.forEach(function(el){el.classList.add('in');});
  }

  var signup=document.getElementById('signup');
  var done=document.getElementById('signupDone');
  var error=document.getElementById('signupError');
  var btn=document.getElementById('signupBtn');
  var email=document.getElementById('signupEmail');
  if(signup && done && btn && email){
    signup.addEventListener('submit',function(event){
      event.preventDefault();
      var emailValue=email.value.trim();
      if(!emailValue || !email.checkValidity()){
        if(error){error.hidden=true;}
        email.style.borderColor='var(--amber)';
        email.setAttribute('aria-invalid','true');
        email.focus();
        return;
      }

      var companyId=signup.getAttribute('data-klaviyo-company-id');
      var listId=signup.getAttribute('data-klaviyo-list-id');
      if(!companyId || !listId){
        if(error){
          error.textContent='Signup is not configured yet. Please try again later.';
          error.hidden=false;
        }
        return;
      }

      email.removeAttribute('aria-invalid');
      email.style.borderColor='';
      if(error){error.hidden=true;}
      btn.disabled=true;
      btn.textContent='Sending...';

      fetch('https://a.klaviyo.com/client/subscriptions?company_id='+encodeURIComponent(companyId),{
        method:'POST',
        headers:{
          'content-type':'application/vnd.api+json',
          'revision':'2026-04-15'
        },
        body:JSON.stringify({
          data:{
            type:'subscription',
            attributes:{
              custom_source:'Homepage Blackout Kit Checklist',
              profile:{
                data:{
                  type:'profile',
                  attributes:{
                    email:emailValue,
                    properties:{
                      lead_magnet:'blackout_kit_checklist',
                      signup_location:'homepage',
                      signup_offer:'12 things every blackout kit needs'
                    },
                    subscriptions:{
                      email:{
                        marketing:{
                          consent:'SUBSCRIBED'
                        }
                      }
                    }
                  }
                }
              }
            },
            relationships:{
              list:{
                data:{
                  type:'list',
                  id:listId
                }
              }
            }
          }
        })
      }).then(function(response){
        if(!response.ok){throw new Error('Klaviyo subscription failed');}
        signup.style.display='none';
        done.style.display='block';
      }).catch(function(){
        if(error){
          error.textContent='We could not send that just now. Please try again.';
          error.hidden=false;
        }
        btn.disabled=false;
        btn.textContent='Send My Checklist';
      });
    });
  }
})();
